export default "__VITE_ASSET__CgrrojmK__"